export default {
  async hasMediaPermissions() {
    //set permission to false if permissions for both audio and video are granted return true, else false and user cannot navigate to the next page.
    try {
      //this is set to true but if we want permissions from the user you can change it in here
      var hasPermission = true;
      const cameraPermission = await navigator.permissions.query({ name: "camera" });
      const microphonePermission = await navigator.permissions.query({ name: "microphone" });
      console.log(cameraPermission);
      console.log(microphonePermission);
      if (cameraPermission.state == "granted" && microphonePermission.state == "granted") {
        console.log("true");
        hasPermission = true;
      }
      return hasPermission;
    } catch (error) {
      console.error('Error checking media permissions:', error);
      return true;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/playtest/Perm-Check.js